import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'newHome',
      meta: {
        title: '首页'
      },
      component: () => import('@/views/newHome')
    },
    // {
    //   path: '/',
    //   name: 'walk',
    //   meta: {
    //     title: '行走长江'
    //   },
    //   component: () => import('@/views/walk')
    // },
    {
      path: '/riverMap',
      name: 'riverMap',
      meta: {
        title: '大江经纬'
      },
      component: () => import('@/views/riverMap')
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        title: '首页'
      },
      component: () => import('@/views/home')
    },
    {
      path: '/common',
      name: 'common',
      meta: {
        title: '数字地球'
      },
      component: () => import('@/views/common'),
      children:[
        {
          path: 'welcome',
          name: 'welcome',
          meta: {
            title: '地球引导'
          },
          // component: () => import('@/views/welcome')
          component: () => import('@/views/boxMap')

        },
        {
          path: 'detail',
          name: 'detail',
          meta: {
            title: '详情'
          },
          // component: () => import('@/views/welcome')
          component: () => import('@/views/graph')

        },
      ]
    },
    {
      path: '/waterTown',
      name: 'waterTown',
      meta: {
        title: '江南水乡'
      },
      component: () => import('@/views/water/common'),
      children:[
        {
          path: 'culture',
          name: 'culture',
          meta: {
            title: '江南文脉'
          },
          component: () => import('@/views/water/boxMap')

        },
        {
          path: 'rhyme',
          name: 'rhyme',
          meta: {
            title: '江南水韵'
          },
          component: () => import('@/views/water/boxMap2')

        },
        {
          path: 'ecology',
          name: 'ecology',
          meta: {
            title: '江南生态'
          },
          component: () => import('@/views/water/boxMap3')

        },
        {
          path: 'graph',
          name: 'graphJN',
          meta: {
            title: '图谱'
          },
          component: () => import('@/views/graph')

        },
      ]
    },
    {
      path: '/compare',
      name: 'compare',
      meta: {
        title: '古今对比'
      },
      component: () => import('@/views/compare/index.vue')

    },
  ]
})
